export const ENTITY_PALETTE = [
  "#E0566B",
  "#5B8DEF",
  "#47B893",
  "#F5A524",
  "#9B59B6",
  "#1ABC9C",
  "#E67E22",
  "#3498DB",
  "#E74C3C",
  "#2ECC71",
  "#8E44AD",
  "#D35400",
] as const

export const CYLINDER_RADIUS_RATIO = 0.13
export const DEFAULT_CHARACTER_HEIGHT_CM = 180
export const DEFAULT_PROP_HEIGHT_CM = 30
export const PRIMITIVE_COLOR = "#B8BDC4"
export const FLOOR_EXTENT = 16

export type PaletteEntityKind = "character" | "prop"

export function paletteColorFor(
  entityType: PaletteEntityKind,
  entityId: number,
  cast: { id: number }[] | null | undefined,
  props: { id: number }[] | null | undefined,
  occupiedColors: string[],
): string {
  const combined: { type: PaletteEntityKind; id: number }[] = [
    ...(cast ?? []).map((c) => ({ type: "character" as const, id: c.id })),
    ...(props ?? []).map((p) => ({ type: "prop" as const, id: p.id })),
  ]
  const index = combined.findIndex((e) => e.type === entityType && e.id === entityId)
  const start =
    (((index >= 0 ? index : entityId) % ENTITY_PALETTE.length) + ENTITY_PALETTE.length) % ENTITY_PALETTE.length
  const occupied = new Set(occupiedColors.map((c) => c.toUpperCase()))
  for (let i = 0; i < ENTITY_PALETTE.length; i++) {
    const color = ENTITY_PALETTE[(start + i) % ENTITY_PALETTE.length]
    if (!occupied.has(color.toUpperCase())) return color
  }
  return ENTITY_PALETTE[start]
}

export function characterSizeFromHeightCm(cm: number): [number, number, number] {
  const h = Math.max(cm, 10) / 100
  const d = h * CYLINDER_RADIUS_RATIO * 2
  return [d, h, d]
}

export function propSizeFromHeightCm(cm: number): [number, number, number] {
  const e = Math.max(cm, 1) / 100
  return [e, e, e]
}
